import '@fortawesome/fontawesome-svg-core/styles.css';
import FullPageErrorBoundary from 'components/FullPageErrorBoundary';
import { ActionCableProvider } from 'contexts/ActionCableContext';
import { AhoyProvider } from 'hooks/useAhoy';
import { useRouter } from 'next/router';
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';
import { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { Provider } from 'react-redux';
import { useStore } from 'redux/store';
import 'styles/globals.css';
import 'styles/lib/typeahead.css';
import 'tailwindcss/tailwind.css';
import { isImpersonated } from 'util/api/auth';
import isBrowser from 'util/isBrowser';
import { BrandContextProvider } from '../contexts/BrandContext';
import { BASE_URL, headers } from '../util/api/client';

function loadGTM() {
  const tagManagerArgs = {
    gtmId: 'GTM-MTSWG66',
  };

  TagManager.initialize(tagManagerArgs);
}

function loadTracking() {
  if (isBrowser() && !isImpersonated() && process.env.NODE_ENV === 'production') {
    loadGTM();
  }
}

// export default function App({ Component, pageProps }) {
function MyApp({ Component, pageProps }) {
  loadTracking();
  const router = useRouter();
  const store = useStore(pageProps.initialReduxState);

  const [ahoy, setAhoy] = useState(null);
  // usePostHog("phc_xKYPEN5TSayrwIjA9272dZ8WCGdxlvjBjocs6yVVShY", {
  //   api_host: "https://app.posthog.com",
  //   loaded: (posthog) => {
  //     if (process.env.NODE_ENV === "development") posthog.opt_out_capturing();
  //   },
  // });

  useEffect(() => {
    // Init PostHog
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      // api_host: "https://app.posthog.com",
      autocapture: false,
      opt_out_capturing_by_default: process.env.NODE_ENV === 'development',
    });

    // Init Ahoy
    if (isBrowser() && !isImpersonated()) {
      void import('ahoy.js').then((ahoyModule) => {
        const ahoySetup = ahoyModule.default;

        ahoySetup.configure({
          withCredentials: true,
          urlPrefix: BASE_URL,
          headers: headers(),
        });

        setAhoy(ahoySetup);
      });
    }

    // Track page views
    const handleRouteChange = () => {
      posthog.capture('$pageview');

      if (ahoy) {
        ahoy.trackView({
          headers: headers(),
        });
        return;
      }

      console.info('[AHOY DEV] trackView', router.pathname);
    };
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);

  return (
    <BrandContextProvider>
      <FullPageErrorBoundary>
        <Provider store={store}>
          <ActionCableProvider>
            <PostHogProvider client={posthog}>
              <AhoyProvider>
                <Component {...pageProps} />
              </AhoyProvider>
            </PostHogProvider>
          </ActionCableProvider>
        </Provider>
      </FullPageErrorBoundary>
    </BrandContextProvider>
  );
}

export default MyApp;
